import { CalendarClock, History, LayoutDashboard, Settings, Zap } from "lucide-react";
import { AdminShell, AdminForbiddenPage } from "@trillion/auth";
import type { NavItem } from "@trillion/ui/components/app-sidebar";
import { RootLayout } from "../layouts/root-layout";
import { LoginPage } from "../pages/login";
import { DashboardPage } from "../pages/dashboard";
import { JobsPage } from "../pages/jobs";
import { JobDetailsPage } from "../pages/job-details";
import { RunsPage } from "../pages/runs";
import { SettingsPage } from "../pages/settings";

const navItems: NavItem[] = [
  { label: "Dashboard", href: "/", icon: LayoutDashboard },
  { label: "Recurring Jobs", href: "/jobs", icon: CalendarClock },
  { label: "Run History", href: "/runs", icon: History },
  { label: "Settings", href: "/settings", icon: Settings },
];

const logo = (
  <div className="flex size-7 items-center justify-center rounded bg-primary text-primary-foreground">
    <Zap className="size-4" />
  </div>
);

/** Run History (sc-114199): `/runs` renders Succeeded and `/runs/:tab` deep-links a tab; `RunsPage`
 *  redirects an unknown tab to `/runs/succeeded`. Exported so the page suite drives this exact route. */
export const runHistoryRoute = { path: "/runs/:tab?", element: <RunsPage /> };

/** One recurring job's details (sc-114201), reached from a Recurring Jobs row (precedent: passport-admin's
 *  `/users/:userId`). `JobDetailsPage` renders a not-found state for an unregistered id. Exported so the page
 *  suite drives this exact route. */
export const jobDetailsRoute = { path: "/jobs/:recurringJobId", element: <JobDetailsPage /> };

export const routes = [
  {
    element: <RootLayout />,
    children: [
      { path: "/login", element: <LoginPage /> },
      { path: "/forbidden", element: <AdminForbiddenPage /> },
      {
        element: <AdminShell appName="Conduit Admin" navItems={navItems} product="conduit" logo={logo} />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: "/jobs", element: <JobsPage /> },
          jobDetailsRoute,
          runHistoryRoute,
          { path: "/settings", element: <SettingsPage /> },
        ],
      },
    ],
  },
];
